import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Pickup from './pages/Pickup';
import Order from './pages/Order';
import OrderSuccess from './pages/OrderSuccess';
import OrderCancel from './pages/OrderCancel';
import CartBadge from './components/CartBadge';
import SiteFooter from './components/SiteFooter';
import HeaderNav from './components/HeaderNav';
import AdminPage from './pages/Admin'
import Checkout from './pages/Checkout'
import OnlineOrderClosed from './pages/OnlineOrderClosed'

const AppShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  display: block;
`;

function App() {
  const location = useLocation();
  const showHeader = location.pathname !== '/';
  return (
    <>
      <CartBadge />
      {showHeader && <HeaderNav />}
      <AppShell>
        <MainContent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/pickup" element={<Pickup />} />
            <Route path="/order" element={<Order />} />
            <Route path="/order/success" element={<OrderSuccess />} />
            <Route path="/order/cancel" element={<OrderCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/technicalerror" element={<OnlineOrderClosed />} />
          </Routes>
        </MainContent>
        <SiteFooter />
      </AppShell>
    </>
  );
}

export default App;
